export enum AppointmentType {
  Reminder = 1,
  Call = 2,
  Meeting = 3,
  Email = 4,
  Task = 5,
  Appointment = 6,
}
